import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const ServiceList = ({
  optionList,
  onChangeHandle,
  value,
  hasError = false,
  errorMessage = "",
  isRquired = true,
  customTitle = <></>,
  titleview = true,
  selectClass = "slds-select",
  searchable = false,
  customSelectStyles,
}) => {
  useEffect(() => {}, [optionList]);
  const { t } = useTranslation(["workpermit", "util"]);

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "38px",
      borderColor: hasError ? "#ea001e" : base.borderColor,
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div
      className={`slds-form-element ${hasError ? "slds-has-error" : ""} select-remove-icon mb-2`}
    >
      {titleview && (
        <label className="slds-form-element__label ">
          {t("service")}
          {isRquired ? (
            <abbr className="slds-required" title="required">
              *{" "}
            </abbr>
          ) : null}
        </label>
      )}
      {customTitle}
      <div className="slds-form-element__control">
        <div className="slds-select_container">
          {searchable ? (
            <Select
              classNamePrefix="clide-searchable-select"
              options={optionList.map((item) => ({
                value: item.service_id,
                label: item.service_name,
              }))}
              value={
                value == null || value === ""
                  ? null
                  : (() => {
                      const found = optionList.find(
                        (item) => String(item.service_id) === String(value),
                      );
                      return found
                        ? { value: found.service_id, label: found.service_name }
                        : null;
                    })()
              }
              onChange={(selectedOption) =>
                onChangeHandle(selectedOption ? selectedOption.value : "")
              }
              placeholder={`${t("select")} ${t("service")}`}
              noOptionsMessage={() => t("noServiceAvailable")}
              isClearable
              menuPlacement="auto"
              menuPosition="absolute"
              //menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              styles={customSelectStyles}
            />
          ) : (
            <select
              className={selectClass}
              onChange={(event) => onChangeHandle(event.target.value)}
              value={value}
            >
              {optionList.length ? (
                <>
                  <option value="">
                    {t("select")} {t("service")}
                  </option>
                  {optionList.map((item, index) => (
                    <option
                      key={`service-option-${index}`}
                      value={item.service_id}
                    >
                      {item.service_name}
                    </option>
                  ))}
                </>
              ) : (
                <option>{t("noServiceAvailable")}</option>
              )}
            </select>
          )}
        </div>
        {hasError ? (
          <div class="slds-form-element__help" id="error-01">
            {errorMessage !== "" ? errorMessage : t("mandatory")}
          </div>
        ) : null}
      </div>
    </div>
  );
};

ServiceList.defaultProps = {
  optionList: [],
  value: "",
  searchable: false,
};

export default ServiceList;
